
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import Head from 'next/head'
import { useRouter } from "next/router";
import React from 'react'
import { GetPageData, GetPlanDetails, GetPlanSlugs, GetCoverageData, 
        GetCitiesAndBrandsData, GetProductAttributesData, GetProductCompareData,
        GetFeaturesData, GetBrandsData} from '../api/plan';
import { GetCategoryLinks, GetCategory} from '../api/home/index';
import Header from '../components/common/Header';
import { Fragment } from 'react';
import PlanBundle from '../components/plan';
import CitySelector from '../components/plan/CitySelector'
import { CtaQuery } from '../components/home/CtaQuery';
import CtaBanner from '../components/common/CtaBanner';
import CategoryList from '../components/home/CategoryList';
import { useState, useEffect } from "react";
import { motion } from 'framer-motion';
import { GetProducts, GetQuestions } from '../api/home/index';
import useSWR from "swr"
import dynamic from "next/dynamic";
import VisibilityManager from "../components/HOC/visibilityManager";
import { GetProducts as Getplans, GetProductsBuild} from '../api/plan';
import Config from '../config';
import { getStaticPath, setUtmCookies, getChannelName, getParamsObjectFromString } from '../utils';
import { redirectIfGenericPage, setSelectedCityInCookie, getCityDisplayName, getSelectedCityFromCookie } from '../utils/cities';
import {productImpression} from '../tracking/ecommerceTracking';
import slug_mappings from '../data/slug_mappings'
import { getPageURL, getPageViewData } from '../utils/tracking';
import { WebsiteSchema, BreadCrumbSchema, ProductSchema, LocalBusinessSchema, FaqSchema } from '@/constants/schema'
import SchemaLoader from '@/components/hoc/SchemaLoader';
import {TESTING_PAGE} from '../city_constants';
import Cookies from 'js-cookie'
import { isMobile } from 'react-device-detect';
const Footer = dynamic(()=> import('../components/common/Footer'),
{loading: () => <p>Loading ...</p>,ssr:true }
);

const UIModal = dynamic(()=> import('../components/common/ui-components/surface/UIModal'),
{loading: () => <p>Loading ...</p>,ssr:true }
);


interface Banner {
  title: string,
  subtitle: string,
  cta_text: string
}

interface PlanSelectionFeatures {
  title: string,
  benefits: {
    priority: number,
    text: string
  }[],
  plan_specific_features?: any,
}

interface Props {
  productType: string,
  faqs: {
    title: string,
    answer: string,
    links: string,
    is_blog: boolean,
  }[],
  testimonials: any[],
  product_compare: any[],
  features: {
    banner: Banner,
    plan_selection: PlanSelectionFeatures,
  },
  brands: string[],
  ac_types?: string[],
  wp_types?: string[],
  ac_capacities?: { value: string, text: string }[],
  questions?: any,
  plans: {
    [index: string]:
    {
      sku: string,
      plan: string,
      unit_price: string,
      amount: boolean,
      title_description: string,
      description_list: any,
      icons_url: string,
      category: string,
      category_type: string,
      category_title: string,
      category_type_title: string,
      product_priority: number,
      location_discount: number
    }[]
  },
  category: string | null,
  category_id:string|number,
  meta_tag_data: any,
  slug_mapping: {
    device: string,
    is_generic: boolean,
    city: any,
    cities_covered: any
  }
}

export async function getStaticPaths() {
  const plan_details = await GetPlanSlugs();
  return {
    paths: plan_details ? plan_details.data : [],
    fallback: false
  }
}

var build_id:any = ""

const Fetcher = async (context:any) => {
  // TODO: Remove Api Call commneted one
  const res: any = await GetPlanDetails({ slug: context.params.slug });
  const faqs: any = await GetPageData({ url: context.params.slug, datas: 'faqs'});
  const blogs: any = await GetPageData({ url: context.params.slug, datas: 'blogs'});
  const cross_sell: any = await GetPageData({ url: context.params.slug, datas: 'cross_sell'});
  const testimonials: any = await GetPageData({ url: context.params.slug, datas: 'testimonials'});
  const bannerImageData: any = await GetPageData({ url: context.params.slug, datas: 'banner_config'});
  const meta_tag_data: any = await GetPageData({ url: context.params.slug, datas: 'meta_tag'});
  const coverageDetails: any = await GetCoverageData({ slug: context.params.slug });
  // const citiesAndBrandsDisplay: any = await GetCitiesAndBrandsData({ slug: context.params.slug });
  // const productAttributes: any = await GetProductAttributesData({ slug: context.params.slug });
  const comparePlan: any = await GetProductCompareData({ slug: context.params.slug });
  // const features: any = await GetFeaturesData({ slug: context.params.slug });
  // const brands: any = await GetBrandsData({ slug: context.params.slug })
  const links: any = await GetCategoryLinks();
  const products: any = await GetProducts();
  const dropquestions: any = await GetQuestions();
  const featured_categories: any = await GetCategory();
  const template: any = await GetPageData({ url: context.params.slug, datas: 'page_template' });
  const categories:any = await GetPageData({url:context.params.slug,datas:'page_categories'});
  const page_meta:any = await GetPageData({url:context.params.slug,datas:'page_meta'});
  const page_product_group:any = await GetPageData({url:context.params.slug,datas:'page_product_group'});
  
  const data = {
    productType: res ? res.data.product_type : '',
    category: res ? res.data.category : null,
    questions: res ? res.data.questions : [],
    device: res ? res.data.device: '',
    category_id: res ? res.data.category_id : '',
    brands: page_meta ? page_meta.data.page_meta.brands || [] : [],
    features: page_meta ? page_meta.data.page_meta.features || []: {},
    ac_types: page_meta ? page_meta.data.page_meta.AC_TYPES || []: [],
    ac_capacities: page_meta ? page_meta.data.page_meta.AC_CAPACITIES || []: [],
    wp_types: page_meta ? page_meta.data.page_meta.WP_TYPES || []: [],
    featured_categories: featured_categories ? featured_categories.data : [],
    brands_display: page_meta ? page_meta.data.page_meta.popularBrands || {}: {},
    cities: page_meta ? page_meta.data.page_meta.display_list || [] : [],
    popular_localities: page_meta ? page_meta.data.page_meta.popularLocalities || {} : {},
    category_links: links ? links.data : [],
    products: products ? products.data : [],
    dropdownquestions: dropquestions ? dropquestions.data : [],
    compare_plan: comparePlan ? comparePlan.data : [],
    coverage_data: coverageDetails ? coverageDetails.data : {},
    faqs: faqs && faqs.data.faqs ? faqs.data.faqs : [],
    blogs: blogs && blogs.data.blogs ? blogs.data.blogs : [],
    cross_sell: cross_sell && cross_sell.data.cross_sell ? cross_sell.data.cross_sell : [],
    testimonials: testimonials && testimonials.data.testimonials ? testimonials.data.testimonials : [],
    bannerImageData: bannerImageData && bannerImageData.data.banner_config ? bannerImageData.data.banner_config : [],
    meta_tag_data: meta_tag_data && meta_tag_data.data.meta_tag ? meta_tag_data.data.meta_tag : [],
    template: template ? template.data.page_template : "",
    categories: categories ? categories.data.page_categories : "",
    page_meta: page_meta ? page_meta.data.page_meta : {},
    product_group: page_product_group ? page_product_group.data.page_product_group : {},
    sort_list:page_meta ? page_meta.data.page_meta.sort_list || [] : [],
    breadcrumb: page_meta ? page_meta.data.page_meta.breadcrumb || [] : [],
    slug_mapping: slug_mappings[context.params.slug] || {}
  }

  return data;
};

const InstaFetcher = async (categories:any, product_group:any, build_type, city:string) => {
  let application = "website"
  let instaplans:any = null;
  
  if(build_type=="buildwebsite"){
    application = build_type;
    instaplans = await GetProductsBuild({
      application: application,
      channel_name: getChannelName(),
      exclude_type: 'Instarepair',
      category__in: categories,
      product_group__in: product_group,
      city:city
    })
  }
  var insta_plans = instaplans && instaplans.data ? instaplans.data.products : []
  return insta_plans
}

 async function _getStaticProps(context: any) {
  const data = await Fetcher(context)
  let split:any = []
  let temp_slug = context.params.slug
  let instaplans:any = ""
  let build_type = "buildwebsite"
  if(build_type){
    if(data.page_meta.prefetcher){
      instaplans = await InstaFetcher(data.categories, data.product_group, build_type, data.slug_mapping.city)  
    }
  }
  return {
    props: {
      data: data,
      instaplans: instaplans,
      pageName: (data.questions.length == 0 ? 'plan-page' : 'questions'),
      layoutConfig: (data.questions.length == 0 ? {
        productType: data.productType
      } : {})
    }
  }
}

const PlanPage = (props: any) => {
  const router = useRouter()
  const slug: any = router.query.slug;
  
  const [show, setShow] = useState(false);
  const [ind, changeInd] = useState(undefined);
  const [open, changeOpen] = useState(false);
  const [questions, getQuestions] = useState([]);
  const [option, setOption] = useState(null);
  const [disabled, changeDisabled] = useState(true)
  const [onetime,setOnetime] = useState(false)
  const [trackslug,settrackSlug] = useState("")
  const {data} = useSWR(slug,Fetcher,{
    initialData: props,
    revalidateOnFocus: false,
    revalidateOnMount: false,
    revalidateOnReconnect: false,
    refreshWhenOffline: false,
    refreshWhenHidden: false,
    refreshInterval: 0,  
  })  
  const BASE_URL = Config.BASE_URL;
  const OG_IMAGE = getStaticPath(props.data.bannerImageData?.og_image || "")
  let split:any = []
  let temp_slug = slug
  let insta_plans = []

  

  temp_slug.replace('-repair-service', '').split('-').forEach(i => {
    split.push(i.replace(i[0], i[0].toUpperCase()))
  })

  let categoryType = split.join(' ')
  categoryType = categoryType.slice(0, categoryType.length - 1)
  const {data:instaplans,mutate}:any = useSWR([categoryType,slug+",plan_page"],InstaFetcher,{
    initialData: props.instaplans,
    revalidateOnMount: true,
    revalidateOnFocus: false,
    revalidateOnReconnect: false
  })  

  if(slug.includes('-repair-service')){
    if(instaplans){
      insta_plans = instaplans
    }
    if(!onetime){
      mutate()
      setOnetime(true)
    }
    if(trackslug !== categoryType){
      settrackSlug(categoryType)
      productImpression(instaplans,"instarepair");
    }
  }  

  useEffect(() => {

    if(!localStorage.getItem('journey_starts_from')){
      // Setting localStorage parameter for GTM
      localStorage.setItem('journey_starts_from', 'direct')
    }
    if(props && props.data && props.data.questions && props.data.questions.length==1){
      router.push(props.data.questions[0].url)
    }
    let params:any = getParamsObjectFromString(window.location.href)['urlParams'];
    if(params['cityreset'])
    {
      setSelectedCityInCookie("")
    }
    redirectIfGenericPage(props.data.slug_mapping, router)
    const timer = setTimeout(() => setShow(true), 300);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => setUtmCookies(window.location.href), []);

  useEffect(()=>{
    let params:any = getParamsObjectFromString(window.location.href)['urlParams'];
    if(params['cityreset']) setSelectedCityInCookie("");
  })

  useEffect(() => {
    let params:any = getParamsObjectFromString(window.location.href)['urlParams'];
    if(params['cityreset'])
    {
      setSelectedCityInCookie("")
    }
    redirectIfGenericPage(props.data.slug_mapping, router)
  },[props.data.slug_mapping])
  
  const cached_props:any = data.data

  const closeModal = () => {
    changeInd(undefined)
    changeDisabled(true)
    router.push('/')
    return false
  }

  const close = () => {
    changeInd(undefined)
    changeDisabled(true)
    changeOpen(false)
    setOption(null)
    return false
  }

  const notSure = (e) => {
      router.push(`?question_popup=${e.value}`)
      window.scrollTo(0, 0)
      setOption(null)
  }


  if (!slug) {
    return null;
  }

  return (
    <motion.div initial="pageInitial" animate="pageAnimate" variants={{
      pageInitial: {
        opacity: 0
      },
      pageAnimate: {
        opacity: 1
      }
    }}
    >
      <Fragment>
        <Head>
          <title>{cached_props.meta_tag_data.tag_title}</title>
          <link rel="icon" href="/favicon.ico" />
          <meta name="description" content={cached_props.meta_tag_data.tag_description}></meta>
          { props.data.slug_mapping?.is_generic && <meta name="ROBOTS" content="NOINDEX"></meta>
          }
          
          <meta property="og:title" content={cached_props.meta_tag_data.tag_title}/>
          <meta property="og:description" content={cached_props.meta_tag_data.tag_description}/>
          <meta property="og:url" content={`${BASE_URL}${router.asPath}`}/>
          <meta property="og:image" content={OG_IMAGE}/>
          <link rel="canonical" href={`${BASE_URL}/${slug}`}></link>
          <SchemaLoader schema={WebsiteSchema} />
          { props.data.faqs.length !== 0 && <SchemaLoader schema={FaqSchema(props)} /> }
          { props.data.breadcrumb.length !== 0 && <SchemaLoader schema={BreadCrumbSchema(props)} /> }
          { props.data.slug_mapping.city && <SchemaLoader schema={LocalBusinessSchema(props)} /> }
          { ProductSchema(props) && ProductSchema(props).map(item => <SchemaLoader schema={item} /> )}
        </Head>
        {cached_props.questions.length === 0 ? (
          <Fragment>
            <VisibilityManager>
              { isVisible => <PlanBundle {...cached_props} slug={slug} router={router} option={option} setOption={setOption} action={notSure} insta_plans={props.instaplans} slug_mapping={props.data.slug_mapping}/> }
            </VisibilityManager>
            <UIModal isOpen={open} onClick={close} larger={true} onOverlayClick={close}>
              <CtaQuery disabled={disabled} changeDisabled={changeDisabled} questions={questions} router={router} ind={ind} changeInd={changeInd} changeOpen={changeOpen} setOption={setOption} />
            </UIModal>
            <CitySelector slug_mapping={props.data.slug_mapping} device_name={props.data.device} />
          </Fragment>
        ) : (
          <Fragment>
            <CtaBanner products={[]} ctaAction={() => {

            }} title="Keep Your Devices In Control" subtitle="Choose from a range of hassle-free and quality repair & maintenance services for electronics. Onsitego is the one-stop solution for all your device problems." />
            <CategoryList list={cached_props.featured_categories}
              onItemClick={() => false}
            />

            <UIModal isOpen={cached_props.questions.length> 1?show: false} onClick={closeModal} larger={true} onOverlayClick={closeModal}>
              <CtaQuery disabled={disabled} changeDisabled={changeDisabled} questions={cached_props.questions ? cached_props.questions : []} router={router} ind={ind} changeInd={changeInd} setShow={setShow}/>
            </UIModal>
          </Fragment>
        )}
      </Fragment>
    </motion.div>
  )
}

export default PlanPage


// @ts-ignore
    export async function getStaticProps(ctx) {
// @ts-ignore
        let res = _getStaticProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/[slug]',
// @ts-ignore
              loaderName: 'getStaticProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  